export const PADDLE_REFUND_POLICY_VERSION = '2026-09-01';
export const PADDLE_REFUND_POLICY_EFFECTIVE_DATE = 'September 1, 2026';
export const PADDLE_REFUND_POLICY_LAST_UPDATED_DATE = 'September 1, 2026';
